import {filterFlyoutIconAssets} from '../../molecules/Filters/assets';
import {pushNotificationIconAssets} from '../../molecules/PushNotification/assets';
import {storeBadgeIconAssets} from '../../molecules/StoreBadge/assets';
import {wishlistIconAssets} from '../../molecules/WishButton/assets';
import {logoIconAssets} from '../../organisms/AboutYouMainLogo/assets';
import {footerIconAssets} from '../../organisms/ContactLinks/assets';
import {headerIconAssets} from '../../organisms/Header/assets';
import {backButtonIconAssets} from '../BackButton/assets';
import {errorPageInlineIconAssets} from '../ErrorPageInline/assets';
import {filterIconAssets} from '../FilterToggleButton/assets';
import {sustainabilityIconAssets} from '../SustainabilityIcon/assets';
import {transparentLogoIconAssets} from '../TransparentLogo/assets';
import {basketIconAssets} from './Basket/basketIconAssets';
import {GenericIconName} from './IconName';
import {wishlistPageIconAssets} from './Wishlist/wishlistPageIconAssets';

import assetIcAboutyouKnob from './assets/svgs/ic-aboutyou-knob.svg';
import assetIcAddCircleFill from './assets/svgs/ic-add-circle-fill.svg';
import assetIcAddToBasketFilled from './assets/svgs/ic-add-to-basket-filled.svg';
import assetIcAddToBasketWithCheckMark from './assets/svgs/ic-add-to-basket-with-check-mark.svg';
import assetIcAddToBasket from './assets/svgs/ic-add-to-basket.svg';
import assetIcAlertError from './assets/svgs/ic-alert-error.svg';
import assetIcAlertSuccess from './assets/svgs/ic-alert-success.svg';
import assetIcAppOnlyCoupon from './assets/svgs/ic-app-only-coupon.svg';
import assetIcAppOnly from './assets/svgs/ic-app-only.svg';
import assetIcArrowDown from './assets/svgs/ic-arrow-down.svg';
import assetIcArrowLeft from './assets/svgs/ic-arrow-left.svg';
import assetIcArrowLongRight from './assets/svgs/ic-arrow-long-right.svg';
import assetIcArrowRight from './assets/svgs/ic-arrow-right.svg';
import assetIcArrowSmallRight from './assets/svgs/ic-arrow-small-right.svg';
import assetIcArrowUpSharpCorners from './assets/svgs/ic-arrow-up-sharp-corners.svg';
import assetIcArrowUp from './assets/svgs/ic-arrow-up.svg';
import assetIcBasketLock from './assets/svgs/ic-basket-lock.svg';
import assetIcBellPlusFilled from './assets/svgs/ic-bell-plus-filled.svg';
import assetIcBellPlus from './assets/svgs/ic-bell-plus.svg';
import assetIcBpgIcon from './assets/svgs/ic-bpg-icon.svg';
import assetIcChat from './assets/svgs/ic-chat.svg';
import assetIcChatbot from './assets/svgs/ic-chatbot.svg';
import assetIcCheckmarkBorder from './assets/svgs/ic-checkmark-border.svg';
import assetIcCheckmarkCircleWhiteCheck from './assets/svgs/ic-checkmark-circle-white-check.svg';
import assetIcCheckmarkCircle from './assets/svgs/ic-checkmark-circle.svg';
import assetIcCheckmarkSmall from './assets/svgs/ic-checkmark-small.svg';
import assetIcCheckmark from './assets/svgs/ic-checkmark.svg';
import assetIcChevronDown from './assets/svgs/ic-chevron-down.svg';
import assetIcClock from './assets/svgs/ic-clock.svg';
import assetIcClose from './assets/svgs/ic-close.svg';
import assetIcCoinsDark from './assets/svgs/ic-coins-dark.svg';
import assetIcCoinsDoubleColorSuccess from './assets/svgs/ic-coins-double-color-success.svg';
import assetIcCoinsDoubleColor from './assets/svgs/ic-coins-double-color.svg';
import assetIcCoinsFilled from './assets/svgs/ic-coins-filled.svg';
import assetIcCoinsStriped from './assets/svgs/ic-coins-striped.svg';
import assetIcCoins from './assets/svgs/ic-coins.svg';
import assetIcConfetti from './assets/svgs/ic-confetti.svg';
import assetIcCopy from './assets/svgs/ic-copy.svg';
import assetIcCouponCloud from './assets/svgs/ic-coupon-cloud.svg';
import assetIcCouponExpired from './assets/svgs/ic-coupon-expired.svg';
import assetIcCouponHintCloud from './assets/svgs/ic-coupon-hint-cloud.svg';
import assetIcCouponNav from './assets/svgs/ic-coupon-nav.svg';
import assetIcCoupon from './assets/svgs/ic-coupon.svg';
import assetIcCoupons from './assets/svgs/ic-coupons.svg';
import assetIcCreditCard from './assets/svgs/ic-credit-card.svg';
import assetIcCrossFill from './assets/svgs/ic-cross-fill.svg';
import assetIcDiscount from './assets/svgs/ic-discount.svg';
import assetIcDoubleArrow from './assets/svgs/ic-double-arrow.svg';
import assetIcDownload from './assets/svgs/ic-download.svg';
import assetIcDropdownUpRight from './assets/svgs/ic-dropdown-up-right.svg';
import assetIcDropdown from './assets/svgs/ic-dropdown.svg';
import assetIcDropsSneaker from './assets/svgs/ic-drops-sneaker.svg';
import assetIcEmptySearch from './assets/svgs/ic-empty-search.svg';
import assetIcErrorCircleFill from './assets/svgs/ic-error-circle-fill.svg';
import assetIcErrorFill from './assets/svgs/ic-error-fill.svg';
import assetIcErrorTriangleColor from './assets/svgs/ic-error-triangle-color.svg';
import assetIcErrorTriangle from './assets/svgs/ic-error-triangle.svg';
import assetIcExternalLinkBordered from './assets/svgs/ic-external-link-bordered.svg';
import assetIcExternalLink from './assets/svgs/ic-external-link.svg';
import assetIcFitAdvisor from './assets/svgs/ic-fit-advisor.svg';
import assetIcFlagReport from './assets/svgs/ic-flag-report.svg';
import assetIcFullscreenOpener from './assets/svgs/ic-fullscreen-opener.svg';
import assetIcGlobe from './assets/svgs/ic-globe.svg';
import assetIcGrabber from './assets/svgs/ic-grabber.svg';
import assetIcGridMultiCol from './assets/svgs/ic-grid-multi-col.svg';
import assetIcGridSingleCol from './assets/svgs/ic-grid-single-col.svg';
import assetIcHashtag from './assets/svgs/ic-hashtag.svg';
import assetIcHeartAdd from './assets/svgs/ic-heart-add.svg';
import assetIcHeartFilled from './assets/svgs/ic-heart-filled.svg';
import assetIcHeart from './assets/svgs/ic-heart.svg';
import assetIcHistory from './assets/svgs/ic-history.svg';
import assetIcInfoFill from './assets/svgs/ic-info-fill.svg';
import assetIcInfoGray from './assets/svgs/ic-info-gray.svg';
import assetIcInfoOutline from './assets/svgs/ic-info-outline.svg';
import assetIcInfoSquaredGray from './assets/svgs/ic-info-squared-gray.svg';
import assetIcInfo from './assets/svgs/ic-info.svg';
import assetIcList from './assets/svgs/ic-list.svg';
import assetIcLock from './assets/svgs/ic-lock.svg';
import assetIcLocked from './assets/svgs/ic-locked.svg';
import assetIcLongArrow from './assets/svgs/ic-long-arrow.svg';
import assetIcLoudspeaker from './assets/svgs/ic-loudspeaker.svg';
import assetIcMailBlack from './assets/svgs/ic-mail-black.svg';
import assetIcMail from './assets/svgs/ic-mail.svg';
import assetIcMerchant from './assets/svgs/ic-merchant.svg';
import assetIcMore from './assets/svgs/ic-more.svg';
import assetIcMute from './assets/svgs/ic-mute.svg';
import assetIcNavBasket from './assets/svgs/ic-nav-basket.svg';
import assetIcNavHeaderBasket from './assets/svgs/ic-nav-header-basket.svg';
import assetIcNavHeaderSearch from './assets/svgs/ic-nav-header-search.svg';
import assetIcNavHeaderWishlist from './assets/svgs/ic-nav-header-wishlist.svg';
import assetIcNavUser from './assets/svgs/ic-nav-user.svg';
import assetIcOpenedBox from './assets/svgs/ic-opened-box.svg';
import assetIcParcel from './assets/svgs/ic-parcel.svg';
import assetIcPauseRound from './assets/svgs/ic-pause-round.svg';
import assetIcPause from './assets/svgs/ic-pause.svg';
import assetIcPercent from './assets/svgs/ic-percent.svg';
import assetIcPhone from './assets/svgs/ic-phone.svg';
import assetIcPlayOutline from './assets/svgs/ic-play-outline.svg';
import assetIcPlay from './assets/svgs/ic-play.svg';
import assetIcPriceInfo from './assets/svgs/ic-price-info.svg';
import assetIcQuestion from './assets/svgs/ic-question.svg';
import assetIcReset from './assets/svgs/ic-reset.svg';
import assetIcRightArrowSharpEdges from './assets/svgs/ic-right-arrow-sharp-edges.svg';
import assetIcRuler from './assets/svgs/ic-ruler.svg';
import assetIcSaleCloud from './assets/svgs/ic-sale-cloud.svg';
import assetIcSaleEvent from './assets/svgs/ic-sale-event.svg';
import assetIcSale from './assets/svgs/ic-sale.svg';
import assetIcSearch from './assets/svgs/ic-search.svg';
import assetIcSecondhandService from './assets/svgs/ic-secondhand-service.svg';
import assetIcSettings from './assets/svgs/ic-settings.svg';
import assetIcShareAndroid from './assets/svgs/ic-share-android.svg';
import assetIcShare from './assets/svgs/ic-share.svg';
import assetIcShirts from './assets/svgs/ic-shirts.svg';
import assetIcSize from './assets/svgs/ic-size.svg';
import assetIcSmallSaleEvent from './assets/svgs/ic-small-sale-event.svg';
import assetIcSmileyHappy from './assets/svgs/ic-smiley-happy.svg';
import assetIcSmileySad from './assets/svgs/ic-smiley-sad.svg';
import assetIcSocialWhatsapp from './assets/svgs/ic-social-whatsapp.svg';
import assetIcSpinner from './assets/svgs/ic-spinner.svg';
import assetIcStarFill from './assets/svgs/ic-star-fill.svg';
import assetIcStarOutline from './assets/svgs/ic-star-outline.svg';
import assetIcSuccessFill from './assets/svgs/ic-success-fill.svg';
import assetIcSustainabilityIcon from './assets/svgs/ic-sustainability-icon.svg';
import assetIcTrash from './assets/svgs/ic-trash.svg';
import assetIcUnlockedFilled from './assets/svgs/ic-unlocked-filled.svg';
import assetIcUnlocked from './assets/svgs/ic-unlocked.svg';
import assetIcUnmute from './assets/svgs/ic-unmute.svg';
import assetIcUser from './assets/svgs/ic-user.svg';
import assetIcUspFreeShipping from './assets/svgs/ic-usp-free-shipping.svg';
import assetIcUspProofOfQuality from './assets/svgs/ic-usp-proof-of-quality.svg';
import assetIcUspReturn from './assets/svgs/ic-usp-return.svg';
import assetIcVip from './assets/svgs/ic-vip.svg';
import assetIcWallet from './assets/svgs/ic-wallet.svg';
import assetIcWarningFill from './assets/svgs/ic-warning-fill.svg';
import assetIcWarning from './assets/svgs/ic-warning.svg';
import assetIcYourFiltersHint from './assets/svgs/ic-your-filters-hint.svg';
import assetInfoSerifWithoutFill from './assets/svgs/info-serif-without-fill.svg';
import assetInfoSerif from './assets/svgs/info-serif.svg';
import assetNotificationCenterEmptyStateImg from './assets/svgs/notificationCenterEmptyStateImg.svg';
import assetSponsoredIcon from './assets/svgs/sponsored-icon.svg';
export const sharedIconAssets = {
  [GenericIconName.SecondHandService]: assetIcSecondhandService,
  [GenericIconName.CouponNav]: assetIcCouponNav,
  [GenericIconName.CheckmarkSmall]: assetIcCheckmarkSmall,
  [GenericIconName.AboutYouKnob]: assetIcAboutyouKnob,
  [GenericIconName.AddCircleFill]: assetIcAddCircleFill,
  [GenericIconName.ArrowUp]: assetIcArrowUp,
  [GenericIconName.ArrowDown]: assetIcArrowDown,
  [GenericIconName.ArrowLeft]: assetIcArrowLeft,
  [GenericIconName.ArrowLongRight]: assetIcArrowLongRight,
  [GenericIconName.ArrowRight]: assetIcArrowRight,
  [GenericIconName.ArrowSmallRight]: assetIcArrowSmallRight,
  [GenericIconName.Chatbot]: assetIcChatbot,
  [GenericIconName.Checkmark]: assetIcCheckmark,
  [GenericIconName.CheckmarkCircle]: assetIcCheckmarkCircle,
  [GenericIconName.CheckmarkCircleWhiteCheck]: assetIcCheckmarkCircleWhiteCheck,
  [GenericIconName.ChevronDown]: assetIcChevronDown,
  [GenericIconName.Coins]: assetIcCoins,
  [GenericIconName.CoinsIconDark]: assetIcCoinsDark,
  [GenericIconName.Coupons]: assetIcCoupons,
  [GenericIconName.CouponCloud]: assetIcCouponCloud,
  [GenericIconName.Dropdown]: assetIcDropdown,
  [GenericIconName.FlagReport]: assetIcFlagReport,
  [GenericIconName.Heart]: assetIcHeart,
  [GenericIconName.HeartAdd]: assetIcHeartAdd,
  [GenericIconName.HeartFilled]: assetIcHeartFilled,
  [GenericIconName.Locked]: assetIcLocked,
  [GenericIconName.Share]: assetIcShare,
  [GenericIconName.ShareAndroid]: assetIcShareAndroid,
  [GenericIconName.AddToBasket]: assetIcAddToBasket,
  [GenericIconName.AddToBasketFilled]: assetIcAddToBasketFilled,
  [GenericIconName.NavBasket]: assetIcNavBasket,
  [GenericIconName.NavHeaderBasket]: assetIcNavHeaderBasket,
  [GenericIconName.NavHeaderWishlist]: assetIcNavHeaderWishlist,
  [GenericIconName.NavHeaderSearch]: assetIcNavHeaderSearch,
  [GenericIconName.NavUser]: assetIcNavUser,
  [GenericIconName.GridSingleCol]: assetIcGridSingleCol,
  [GenericIconName.GridMultiCol]: assetIcGridMultiCol,
  [GenericIconName.Search]: assetIcSearch,
  [GenericIconName.Info]: assetIcInfo,
  [GenericIconName.InfoFill]: assetIcInfoFill,
  [GenericIconName.InfoFilled]: assetInfoSerif,
  [GenericIconName.InfoSponsored]: assetSponsoredIcon,
  [GenericIconName.InfoWithoutFill]: assetInfoSerifWithoutFill,
  [GenericIconName.InfoFilledGray]: assetIcInfoGray,
  [GenericIconName.InfoSquaredGray]: assetIcInfoSquaredGray,
  [GenericIconName.Close]: assetIcClose,
  [GenericIconName.Download]: assetIcDownload,
  [GenericIconName.Error]: assetIcWarningFill,
  [GenericIconName.EmptySearch]: assetIcEmptySearch,
  [GenericIconName.ExternalLink]: assetIcExternalLink,
  [GenericIconName.ExternalLinkBordered]: assetIcExternalLinkBordered,
  [GenericIconName.AlertSuccess]: assetIcAlertSuccess,
  [GenericIconName.AlertSuccessFill]: assetIcSuccessFill,
  [GenericIconName.AlertErrorFill]: assetIcErrorFill,
  [GenericIconName.AlertErrorCircleFill]: assetIcErrorCircleFill,
  [GenericIconName.Discount]: assetIcDiscount,
  [GenericIconName.Vip]: assetIcVip,
  [GenericIconName.AlertError]: assetIcAlertError,
  [GenericIconName.Clock]: assetIcClock,
  [GenericIconName.Globe]: assetIcGlobe,
  [GenericIconName.Reset]: assetIcReset,
  [GenericIconName.DoubleArrow]: assetIcDoubleArrow,
  [GenericIconName.ParcelBox]: assetIcParcel,
  [GenericIconName.Ruler]: assetIcRuler,
  [GenericIconName.UspProofOfQuality]: assetIcUspProofOfQuality,
  [GenericIconName.List]: assetIcList,
  [GenericIconName.Warning]: assetIcWarning,
  [GenericIconName.WarningFill]: assetIcWarningFill,
  [GenericIconName.USPReturn]: assetIcUspReturn,
  [GenericIconName.More]: assetIcMore,
  [GenericIconName.Trash]: assetIcTrash,
  [GenericIconName.Hashtag]: assetIcHashtag,
  [GenericIconName.Mail]: assetIcMail,
  [GenericIconName.Size]: assetIcSize,
  [GenericIconName.SaleEvent]: assetIcSaleEvent,
  [GenericIconName.SmallSaleEvent]: assetIcSmallSaleEvent,
  [GenericIconName.Phone]: assetIcPhone,
  [GenericIconName.SocialWhatsapp]: assetIcSocialWhatsapp,
  [GenericIconName.MailBlack]: assetIcMailBlack,
  [GenericIconName.User]: assetIcUser,
  [GenericIconName.SmileyHappy]: assetIcSmileyHappy,
  [GenericIconName.SmileySad]: assetIcSmileySad,
  [GenericIconName.QuestionMark]: assetIcQuestion,
  [GenericIconName.Sale]: assetIcSale,
  [GenericIconName.Percent]: assetIcPercent,
  [GenericIconName.FullscreenOpener]: assetIcFullscreenOpener,
  [GenericIconName.Pause]: assetIcPause,
  [GenericIconName.Play]: assetIcPlay,
  [GenericIconName.Mute]: assetIcMute,
  [GenericIconName.Unmute]: assetIcUnmute,
  [GenericIconName.YourFiltersHint]: assetIcYourFiltersHint,
  [GenericIconName.StarFilled]: assetIcStarFill,
  [GenericIconName.FitAdvisor]: assetIcFitAdvisor,
  [GenericIconName.SearchHistory]: assetIcHistory,
  [GenericIconName.SaleCloud]: assetIcSaleCloud,
  [GenericIconName.Bell]: assetIcBellPlus,
  [GenericIconName.BellFilled]: assetIcBellPlusFilled,
  [GenericIconName.DropdownUpRight]: assetIcDropdownUpRight,
  [GenericIconName.UspFreeShipping]: assetIcUspFreeShipping,
  [GenericIconName.Lock]: assetIcLock,
  [GenericIconName.Settings]: assetIcSettings,
  [GenericIconName.Help]: assetIcChat,
  [GenericIconName.CreditCard]: assetIcCreditCard,
  [GenericIconName.StarOutline]: assetIcStarOutline,
  [GenericIconName.Coupon]: assetIcCoupon,
  [GenericIconName.Merchant]: assetIcMerchant,
  [GenericIconName.NotificationCenterEmptyState]:
    assetNotificationCenterEmptyStateImg,
  [GenericIconName.BestPriceGuaranteeWallet]: assetIcBpgIcon,
  [GenericIconName.Loudspeaker]: assetIcLoudspeaker,
  [GenericIconName.SustainabilityLeaf]: assetIcSustainabilityIcon,
  [GenericIconName.InfoOutline]: assetIcInfoOutline,
  [GenericIconName.AppOnlyCoupon]: assetIcAppOnlyCoupon,
  [GenericIconName.AppOnlyIcon]: assetIcAppOnly,
  [GenericIconName.ArrowUpSharpCorners]: assetIcArrowUpSharpCorners,
  [GenericIconName.CouponExpired]: assetIcCouponExpired,
  [GenericIconName.ErrorTriangle]: assetIcErrorTriangle,
  [GenericIconName.AddToBasketWithCheckMark]: assetIcAddToBasketWithCheckMark,
  [GenericIconName.PauseRound]: assetIcPauseRound,
  [GenericIconName.RightArrowSharpEdges]: assetIcRightArrowSharpEdges,
  [GenericIconName.ErrorTriangleColor]: assetIcErrorTriangleColor,
  [GenericIconName.couponHintCloud]: assetIcCouponHintCloud,
  [GenericIconName.copy]: assetIcCopy,
  [GenericIconName.Unlocked]: assetIcUnlocked,
  [GenericIconName.UnlockedFilled]: assetIcUnlockedFilled,
  [GenericIconName.CoinsStriped]: assetIcCoinsStriped,
  [GenericIconName.CoinsFilled]: assetIcCoinsFilled,
  [GenericIconName.CoinsDoubleColor]: assetIcCoinsDoubleColor,
  [GenericIconName.CoinsDoubleColorSuccess]: assetIcCoinsDoubleColorSuccess,
  [GenericIconName.BasketLock]: assetIcBasketLock,
  [GenericIconName.LongArrow]: assetIcLongArrow,
  [GenericIconName.CrossFill]: assetIcCrossFill,
  [GenericIconName.CheckmarkBorder]: assetIcCheckmarkBorder,
  [GenericIconName.PlayOutline]: assetIcPlayOutline,
  [GenericIconName.DropsSneaker]: assetIcDropsSneaker,
  [GenericIconName.PriceInfo]: assetIcPriceInfo,
  [GenericIconName.Grabber]: assetIcGrabber,
  [GenericIconName.Confetti]: assetIcConfetti,
  [GenericIconName.OpenedBox]: assetIcOpenedBox,
  [GenericIconName.Shirts]: assetIcShirts,
  [GenericIconName.Spinner]: assetIcSpinner,
  [GenericIconName.Wallet]: assetIcWallet,
  ...filterIconAssets,
  ...filterFlyoutIconAssets,
  ...sustainabilityIconAssets,
  ...wishlistIconAssets,
  ...errorPageInlineIconAssets,
  ...headerIconAssets,
  ...logoIconAssets,
  ...footerIconAssets,
  ...basketIconAssets,
  ...backButtonIconAssets,
  ...transparentLogoIconAssets,
  ...pushNotificationIconAssets,
  ...storeBadgeIconAssets,
  ...wishlistPageIconAssets,
} as const;
